<div class="cv-drag-and-drop-file cv-drag-and-drop-file-component">
	<div class="cv-test">
		<textarea class="item-value" (click)="onChange($event)"></textarea>
	</div>
	<div class="upload-file__container" cvDragDropFile (filesDropped)="onFilesDropped($event)">
		<div class="context-text__container">
			<label class="custom__lbl">{{message}}</label>
			<hr />
			<label class="action__lbl"><i class="fas fa-hand-rock"></i> Drag and Drop image here</label>
			<input #fileInput
			   hidden
			   [accept]="acceptFormat"
			   type="file" (change)="onFilesChanged($event)">
			<label class="sub__lbl">or</label>
			<button class="browse-files__btn btn btn-sm btn-light" (click)="fileInput.click()">Browse Files</button>
			<p><strong>Required</strong></p>
			<div *ngIf="formatNotSupported" class="upload-file__format-not-supported">
				<span class="format-error">The file format is not supported</span>
				<span>Please try a valid format:
					<span *ngFor="let format of fileExtensionFormats[acceptFormat]; let last = last;">
						.{{format}}<span *ngIf="!last" class="comma">, </span>
					</span>
				</span>
				<br />
			</div>
		</div>
	</div>
	<div  class="files-list" *ngFor="let file of files;let i= index">
		<div class="file-type__container">
			<i class="fas {{fileTypeImg(file.name)}}"></i>
		</div>
		<div class="file-details__container">
			<label>{{ file.name }}</label>
			<label>{{ formatBytes(file.size) }}</label>
		</div>
		<button class="delete-file" (click)="deleteAttachment(i)">
			<i class="fas fa-trash"></i>
		</button>
	</div>
</div>
